import React from 'react'

import { Input } from 'ui/components/Input'
import { InputEndActionNumber } from 'ui/components/Input/InputEndActionNumber'
import { Body } from 'ui/components/Text'

import { useSectionCurrencyAttributeEditorState } from './hooks/useSectionCurrencyAttributeEditorState'
import { SectionAttributeEditorProps } from './types'

type SectionCurrencyAttributeEditorProps = SectionAttributeEditorProps<number>

export const SectionCurrencyAttributeEditor: React.FC<SectionCurrencyAttributeEditorProps> = ({
    label,
    value,
    onChange,
    isReadOnly,
    field,
    placeholder,
}) => {
    const { localValue, handleChange, currencySign } = useSectionCurrencyAttributeEditorState({
        value,
        onChange,
        field,
    })

    return (
        <Input
            type="number"
            size="m"
            label={label}
            value={localValue}
            onChange={handleChange}
            endAction={InputEndActionNumber}
            startAction={() => (
                <Body size="m" color="textWeaker" mr="3xs" noShrink>
                    {currencySign}
                </Body>
            )}
            readOnly={isReadOnly}
            placeholder={placeholder}
        />
    )
}
